<template>
  <!-- 用户管理-用户限制消费 -->
  <div class="user_limit_consumption-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            style="width: 150px"
            clearable
            v-model.trim="query.user_id"
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column
          prop="limit_amount"
          label="最大充值限制"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="continuous_days" label="限制天数" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="danger" v-if="row.status === 1">限制中</el-tag>
            <el-tag type="info" v-if="row.status === 0">已解除</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          label="开始时间"
          min-width="150px"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="操作"
          align="center"
          width="200px"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" @click="openEditDialog(row)">
              编辑
            </el-button>
            <el-button type="danger" @click="deleteEvent(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 编辑用户限制 -->
    <EditUserLimitConsumption
      :visible="editLimitVisible"
      v-model="dialogInfo"
      @refresh="getData"
      @close="editLimitVisible = false"
    ></EditUserLimitConsumption>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData, getApiData, patchApiData, postApiData, delApiData } from '@/http'
import EditUserLimitConsumption from '@/components/user/user_limit_consumption/EditUserLimitConsumption.vue'

export default {
  name: 'user_limit_consumption',
  components: {
    EditUserLimitConsumption
  },
  data() {
    return {
      editLimitVisible: false,//编辑限制弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        user_id: undefined,//用户id
      },
      dialogInfo: undefined,//传给弹窗的数据
      dataList: undefined,//数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  watch: {
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      //获取列表数据
      this.loading = true
      let params = this.query
      getApiData('limit_consumption', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openEditDialog(rowInfo) {
      //打开编辑弹窗
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
      this.editLimitVisible = true

    },
    deleteEvent(rowInfo) {
      //删除限制
      let params = {
        id: rowInfo.id
      }
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`limit_consumption`, params).then(res => {
          this.$message.success('删除成功！')
          this.getData()
        })
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.user_limit_consumption-box {
  header {
  }

  .body-box {
  }
}
</style>